import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';
import { useSelector } from 'react-redux';
import { propsToJS } from '__utils/immutable-to-js';
import { LayoutContext } from 'components/app-routes';
import { COLOR } from 'constants/colors';
import { WhiteCardWrapper } from 'views/common-styled-components';
import UserBankInfoSlab from '../user-bank-info-slab';
import { Row, Col } from 'antd';
import PaymentViewSelector from '../payment-flow.selector';
import NeftForm from './neft-form';
import { copyHTMLToClipboard } from '__utils/copy-html-to-clipboard';
import copyTextIcon from 'images/copy.svg';
import useFlashToggler from 'hooks/use-flash-toggler';
import VerifiedMark from 'components/verified-icon-text';
import { addAgentCode, isProUser } from '__utils/common-utils';
import { PaymentFlowHelper } from '../paymentFlow.helper';


const StepsContainer = styled.div<CommonStyledComponentProps>`
    list-style: none;
    position: relative;
    label{
        font-weight: 500;
        font-size: 14px;
    }
`;

const Step = styled.div<CommonStyledComponentProps>`
    flex: 1;
`;

const PayStep = styled.div<CommonStyledComponentProps>`

    position: relative;
    h5 {
        font-size: 16px;
        color: ${COLOR.GREEN};
        line-height: normal;
        font-weight: 500;
        padding: 10px 0px
    }

    p {
        font-size: 14px;
        line-height: 1.14;
    }
    .pay-details {
        margin-bottom: 16px;
    }
    .pay-details p {
        color: #a1a6a7;
        line-height: 1.5;
    }

    .pay-details p span {
        color: #212121;
        font-weight: bold;
    }
`;

const NeftPayment: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { totalValidOrdersAmount,userPaymentDetailView } = propsToJS(useSelector(PaymentViewSelector));
    // eslint-disable-next-line
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const { getBSEorderDetails } = PaymentFlowHelper();
    const flash = useFlashToggler();

    useEffect(() => {
        SetLayoutProps({
            config: { title: 'NEFT/RTGS Payment' },
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Investment Cart', url: '/cart-review', isExternal: true }, { text: 'NEFT/RTGS Payment Steps', url: '' } ],
            showBseInfoForDesktop: true,
            showBseInfoForMobile: true,
            showCopyrightInfoForDesktop: true,
            showCopyrightInfoForMobile: true
        })
        userPaymentDetailView && userPaymentDetailView?.length === 0 && getBSEorderDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const copyDetails = () => {
        copyHTMLToClipboard();
        flash.success('Copied');
    }

    const getContent = () => {
        return <>
            { isMobile && <div style={ { margin: '16px', marginTop: isProUser() ? '24px' : '60px' } }>
                <UserBankInfoSlab />
            </div> }
            <Row gutter={ 32 } style={ { width: '100%', margin: '0px auto', padding: '0' } }>
                <Col xs={ 24 } md={ 16 } style={ { padding: '0' } }>
                    <WhiteCardWrapper isMobile={ isMobile } style={ { width: isMobile ? '90vw' : '100%', height: '100%', paddingRight: isMobile ? '16px' : '24px' } }>
                        <StepsContainer isMobile={ isMobile }>
                            { !isMobile && <div>
                                <UserBankInfoSlab vertical /> <br />
                            </div> }
                            <Step isMobile={ isMobile }>
                                <PayStep isMobile={ isMobile }>
                                    <div className="line">
                                        <span className="dot"></span>
                                        <div style={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                                            <h5>Step 1</h5>
                                            <VerifiedMark />
                                        </div>
                                        <p>Make NEFT/RTGS transfer from registered bank account for following credentials.
                                            You can do the transfer using net banking or by going to your bank branch.</p>
                                        <br />
                                        <div style={ { display: 'flex', justifyContent: 'space-between', alignItems: 'self-start' } }>
                                            <div className="pay-details">
                                                <p className='text_to_copy'>
                                                    Name of bank : <span>HDFC Bank</span>
                                                </p>
                                                <p className='text_to_copy'>
                                                    Bank Beneficiary name	 : <span>Indian Clearing Corporation Ltd - MFD A/c	</span>
                                                </p>
                                                <p className='text_to_copy'>
                                                    Benficiary account no : <span>MFDICC</span>
                                                </p>
                                                <p className='text_to_copy'>
                                                    IFSC code : <span>HDFC0000240</span>
                                                </p>
                                                <p className='text_to_copy'>
                                                    Account type : <span>Current</span>
                                                </p>
                                            </div>
                                            <img src={ copyTextIcon } style={ { marginRight: isMobile ? '8px' : '24px', cursor: 'pointer' } } onClick={ copyDetails } />
                                        </div>
                                    </div>
                                </PayStep>
                            </Step>
                            { isMobile && <NeftForm /> }
                        </StepsContainer>
                    </WhiteCardWrapper>
                </Col>

                <Col xs={ 0 } md={ 8 } style={ { padding: '0 0 0 32px ' } }>
                    <div className='mint-box flex-col-container' style={ { height: '100%' } }>
                        { !isMobile && <>
                            <Row style={ { justifyContent: 'space-between', marginBottom: '8px' } }>
                                <Col style={ { color: '#4D5556', fontSize: '18px' } }>
                                    Total Investment :
                                </Col>
                                <Col >
                                    <b className='totalAmountTitle'> ₹ { totalValidOrdersAmount?.toLocaleString(navigator.language, { minimumFractionDigits: 2 }) }</b>
                                </Col>
                            </Row>
                            <NeftForm />
                        </>
                        }
                    </div>
                </Col>
            </Row>
        </>
    }
    return (
        <div style={ { marginBottom: '30px' } }>
            { getContent() }
        </div>)

}

export default NeftPayment;
